import { siteUrl } from '../api.ts';

/**
 * How order texts work. Linked from the checkout checkbox, and the page carriers and Twilio read
 * when the texting campaign is registered, so it states the program plainly: what is sent, how
 * often, what it costs, how to stop, and that numbers are never shared.
 */
export function TextTermsPage() {
  return (
    <article style={{ display: 'grid', gap: 16, maxWidth: 640, lineHeight: 1.55 }}>
      <h1 style={{ margin: 0, fontSize: 28 }}>Text message terms</h1>
      <p style={{ margin: 0 }}>
        Crave Pizza order texts are updates about an order you placed with us. You get them only
        when you tick “Text me about this order” at checkout, and only about that order.
      </p>
      <section style={{ display: 'grid', gap: 8 }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>What we send</h2>
        <ul style={{ margin: 0, paddingLeft: 22, display: 'grid', gap: 4 }}>
          <li>A text when your order is booked, with your pickup time and a link to track it.</li>
          <li>A text when your order is ready for pickup.</li>
          <li>A text if your order is canceled.</li>
        </ul>
        <p style={{ margin: 0 }}>
          That is at most three automated texts per order. Each one starts with “Crave Pizza
          (automated)” and ends with “Reply STOP to opt out.” We never send marketing or promotions
          by text.
        </p>
        <p style={{ margin: 0 }}>
          You can also text us at this number with a question about your order. A person from our
          team reads it and replies.
        </p>
      </section>
      <section style={{ display: 'grid', gap: 8 }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>Stopping texts and getting help</h2>
        <p style={{ margin: 0 }}>
          Reply <strong>STOP</strong> to any text to opt out of all texts from us, and{' '}
          <strong>START</strong> to opt back in. Reply <strong>HELP</strong> for help, or reach us
          through{' '}
          <a href={siteUrl} style={{ color: 'var(--ink)', fontWeight: 600 }}>
            cravepizzafl.com
          </a>
          . Message and data rates may apply. Message frequency varies with your orders. Carriers
          are not liable for delayed or undelivered messages.
        </p>
      </section>
      <section style={{ display: 'grid', gap: 8 }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>Your number</h2>
        <p style={{ margin: 0 }}>
          We use your mobile number only to text you about your order. We do not sell, rent or share
          mobile numbers or text consent with anyone for their marketing. Our texts are delivered
          through Twilio, which handles your number only to deliver them.
        </p>
      </section>
    </article>
  );
}
